import { render, staticRenderFns } from "./CreateUserStepPersonalDetails.vue?vue&type=template&id=d4c3ea04&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports